export default __webpack_public_path__ + "static/media/diba-ayo-sekolah-removebg.e7d2241d.png";